export default __webpack_public_path__ + "images/ae61e073488a6e9ba97abc8773193ac5-robotics_small.webp";